<div class="portal-footer" #footer [innerHTML]="footerContent"></div>
